'use client';

import { Flixmedia } from './scripts/Flixmedia/Flixmedia.dynamic.client';
import { HappyContest } from './scripts/HappyContest/HappyContest.dynamic.client';
import { KuecheCo } from './scripts/KuecheCo/KuecheCo.dynamic.client';
import { Loadbee } from './scripts/Loadbee/Loadbee.dynamic.client';
import { MarketingChaeschtli } from './scripts/MarketingChaeschtli/MarketingChaeschtli.dynamic.client';
import { SmartAssistant } from './scripts/SmartAssistant/SmartAssistant.dynamic.client';
import { Sovendus } from './scripts/Sovendus/Sovendus.dynamic.client';
import { Squarelovin } from './scripts/Sqarelovin/Squarelovin.dynamic.client';
import { TrustedShops } from './scripts/TrustedShops/TrustedShops.dynamic.client';
import { Zoovu } from './scripts/Zoovu/Zoovu.dynamic.client';
import type { ExternalScriptType } from './types';

/**
 * This component creates "div-replacement" containers for different providers.
 * Into these placeholders external content will be placed using GTM with push into the data layer.
 *
 * @param data Object contains data
 * @returns JSX.Element to be placed in PageLayout
 */
export const ExternalScript = ({ data }: { data: ExternalScriptType }) => {
  if (data.type === 'external_script_happycontest') {
    return <HappyContest id={data.field_id} src={data.field_src} />;
  }

  if (data.type === 'external_script_loadbee') {
    return (
      <Loadbee
        externalApiKey={data.field_api_key}
        brand={data.field_shop_id}
        urlProducts={data.field_url_products}
      />
    );
  }

  if (data.type === 'externalscript') {
    const { field_script_type: scriptType, field_api_key: externalApiKey } = data;

    if (scriptType === 'sovendus') {
      return <Sovendus />;
    }
    if (scriptType === 'squarelovin_main_stream') {
      return <Squarelovin streamType="gallery" />;
    }
    if (scriptType === 'squarelovin_teaser_stream') {
      return <Squarelovin streamType="teaser" />;
    }
    if (externalApiKey) {
      switch (scriptType) {
        case 'kueche_co':
          return <KuecheCo journey={externalApiKey} />;
        case 'marketing_chaeschtli':
          return <MarketingChaeschtli id={externalApiKey} />;
        case 'smartAssistant':
          return <SmartAssistant advisorCode={externalApiKey} />;
        case 'trustedShops':
          return <TrustedShops externalApiKey={externalApiKey} />;
        case 'zoovu':
          return <Zoovu advisorId={externalApiKey} />;
        case 'zoovu_url':
          return <Zoovu zoovuURL={externalApiKey} />;
        case 'flixmedia':
          return <Flixmedia descriptor={externalApiKey} />;
        default:
          break;
      }
    }
  }

  return <div data-testid="no matching script type" />;
};
